import { instance } from "libs/api";

import {
  AddEmailRecipientBody,
  EmailNotificationRecipient
} from "../../emailNotifications.types";
import { ApiRoutesEmailNotifications } from "../../constants";

export const requestAddEmailRecipient = async (
  body: AddEmailRecipientBody
): Promise<EmailNotificationRecipient> => {
  return await instance.post(ApiRoutesEmailNotifications.Recipients, body);
};
